<app-list2 listId="core-configuration-view" (onSingleItemOperation)="onSingleItemOperation($event)">
</app-list2>
